// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__7L7l3","root":"styles_root__nyFu-","important":"styles_important__O+NSp","overdue":"styles_overdue__fxOd7"};